export const buildNumber = '20260617.4';
export const version = 'main';
export const latestCommit = 'ec38f6cdcb122e12c08c10461658851939b0e2c7';
